import apiClient from './api';

export const opcionService = {
  // Listar todas las opciones
  getAllOpciones: async () => {
    const response = await apiClient.get('/opciones');
    return response.data;
  },

  // Listar opciones por pregunta
  getOpcionesByPregunta: async (preguntaId) => {
    const response = await apiClient.get(`/opciones/pregunta/${preguntaId}`);
    return response.data;
  },

  // Crear nueva opción
  createOpcion: async (opcionData) => {
    const response = await apiClient.post('/opciones', opcionData);
    return response.data;
  },

  // Actualizar opción
  updateOpcion: async (id, opcionData) => {
    const response = await apiClient.put(`/opciones/${id}`, opcionData);
    return response.data;
  },

  // Eliminar opción
  deleteOpcion: async (id) => {
    const response = await apiClient.delete(`/opciones/${id}`);
    return response.data;
  },

  // Crear opción con imagen (FormData)
  createOpcionWithImage: async (formData) => {
    const response = await apiClient.post('/opciones', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Actualizar opción con imagen (FormData)
  updateOpcionWithImage: async (id, formData) => {
    const response = await apiClient.put(`/opciones/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};

export default opcionService;
